module.exports = __webpack_public_path__ + "media/images/icons/info_red-28b7ab03b0967f5c6e03d68367436410.svg";